import * as React from 'react';
import {Link} from 'react-router-dom';
import {withTranslation} from 'react-i18next';
import s from './goToFirstPage.scss';
type GoToFirstPageLinkProps = {
  active: boolean,
  hide: boolean,
  path: string,
  page: number,
  t: (...args: any[]) => any
};
class GoToFirstPageLink extends React.Component<GoToFirstPageLinkProps, {}> {
  render() {
    const {t, active, hide, path} = this.props;
    return (
      <li
        data-hooks="go-to-first-page"
        data-disabled={active}
        data-hide={hide}
        className={s.link}
      >
        <Link to={path}>
          <span className={s.hidden}>{t('navigate-to-first-page')}</span>
          <svg
            role="button"
            version="1.1"
            className={s.prev}
            viewBox="-301.3 8.3 12.2 9"
            x="0"
            y="0"
            xmlSpace="preserve"
            aria-labelledby="navigate-to-first-page-arrow"
          >
            <title id="navigate-to-first-page-arrow">
              {t('navigate-to-first-page')}
            </title>
            <polygon points="-293.5 17.3 -294.1 16.6 -290.4 12.8 -294.1 8.9 -293.5 8.3 -289.1 12.8" />
            <polygon points="-300.7 17.3 -301.3 16.6 -297.6 12.8 -301.3 8.9 -300.7 8.3 -296.3 12.8" />
          </svg>
        </Link>
      </li>
    );
  }
}
export default withTranslation()(GoToFirstPageLink);
